export default __webpack_public_path__ + "static/media/038-syringe.4bc789bf.svg";